<div class="container" style="max-width: 700px">
  <div *ngIf="mensaje" class="text-center">
    <h3>{{ mensaje }}</h3>
  </div>

  <div *ngIf="!mensaje">
    <div *ngIf="paciente && !loading; else loadingTemplate">
      <div class="row">
        <div class="col-md-12">
          <form
            class="gx-3 gy-2 align-items-center"
            [formGroup]="formConsentimiento"
          >
            <h5
              class="font-size-35 mb-3"
              style="text-align: center; margin-top: 5%; margin-bottom: 10%"
            >
              CONSENTIMIENTO INFORMADO
            </h5>
            <h5
              class="font-size-14 mb-3"
              style="text-align: center; margin-top: 5%; margin-bottom: 10%"
            >
              <p style="font-weight: bold">
                Psicologa.co – Especialistas En Salud Mental S.A.S
              </p>
              <p></p>
              <p style="font-weight: lighter">Linea de atención 3148131016</p>
              <p style="font-weight: lighter">
                ¿Qué es un consentimiento informado?
              </p>
              <p style="font-weight: lighter">
                Este es el proceso en el que se proporciona información
                importante al paciente, de acuerdo con los parámetros
                instituidos en las normas y jurisprudencia que atiende la
                materia, tales como, los riesgos y beneficios posibles del
                tratamiento propuesto.
              </p>
            </h5>
            <div class="m-3">
              <div class="row">
                <h5 class="font-size-14 mb-3">
                  <p style="font-weight: bold">1. INFORMACIÓN PERSONAL</p>
                </h5>
                <div class="col-md-6">
                  <label for="nombres" class="form-label text-muted"
                    >Nombres</label
                  >
                  <p>
                    <strong>{{ paciente.nombres }}</strong>
                  </p>
                </div>
                <div class="col-md-6">
                  <label for="apellidos" class="form-label text-muted"
                    >Apellidos</label
                  >
                  <p>
                    <strong>{{ paciente.apellidos }}</strong>
                  </p>
                </div>

                <div class="col-md-6 mb-3">
                  <label class="form-label text-muted">Sexo</label>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="sexo"
                      id="formRadios1"
                      formControlName="sexo"
                      value="M"
                      checked
                    />
                    <label class="form-check-label" for="formRadios1">
                      Hombre
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="sexo"
                      id="formRadios2"
                      formControlName="sexo"
                      value="F"
                    />
                    <label class="form-check-label" for="formRadios2">
                      Mujer
                    </label>
                  </div>
                </div>
                <div class="col-md-6">
                  <label for="fnacimiento" class="form-label text-muted"
                    >Fecha Nacimiento</label
                  >
                  <p>
                    <strong>{{
                      paciente?.fnacimiento | date : "dd / MM / yyyy" : "UTC"
                    }}</strong>
                  </p>
                </div>

                <div class="col-md-6">
                  <label for="tDocumento" class="form-label text-muted"
                    >Tipo Documento</label
                  >
                  <p>
                    <strong>{{ paciente.tDocumento.tipo }}</strong>
                  </p>
                </div>
                <div class="col-md-6">
                  <label for="identificacion" class="form-label text-muted"
                    >Documento</label
                  >
                  <p>
                    <strong>{{ paciente.identificacion }}</strong>
                  </p>
                </div>

                <div class="col-md-6 mb-3">
                  <label for="celular" class="form-label text-muted"
                    >Celular</label
                  >
                  <p>
                    <strong>{{ paciente.celular }}</strong>
                  </p>
                </div>
                <div class="col-md-6">
                  <label for="email" class="form-label text-muted"
                    >Email
                  </label>
                  <p>
                    <strong>{{ paciente.email }}</strong>
                  </p>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="idEps" class="form-label text-muted">EPS</label>

                  <ng-select
                    [items]="eps"
                    bindValue="$id"
                    bindLabel="entidad"
                    placeholder="Seleccione"
                    appendTo="body"
                    [multiple]="false"
                    formControlName="idEps"
                  >
                  </ng-select>
                </div>
                <p></p>
                <h5 class="font-size-14 mb-3">
                  <p style="font-weight: bold">
                    2. PAÍS EN EL QUE SE REALIZAN LAS SESIONES
                  </p>
                </h5>
                <p></p>

                <div class="col-lg-6" *ngIf="ubicacion">
                  <div class="mb-3">
                    <label class="form-label">País </label>
                    <p>
                      <strong>{{ ubicacion.country_name }}</strong>
                    </p>
                  </div>
                </div>

                <div class="col-lg-6" *ngIf="ubicacion">
                  <div class="mb-3">
                    <label class="form-label">Dto Residencia</label>
                    <p>
                      <strong>{{ ubicacion.state_name }}</strong>
                    </p>
                  </div>
                </div>

                <div class="col-lg-6" *ngIf="ubicacion">
                  <div class="mb-3">
                    <label class="form-label">Ciudad Residencia</label>
                    <p>
                      <strong>{{ ubicacion.name }}</strong>
                    </p>
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="mb-3">
                    <label for="direccionResidencia" class="form-label"
                      >Dirección Residencia</label
                    >
                    <p>
                      <strong>{{ paciente.direccionResidencia }}</strong>
                    </p>
                  </div>
                </div>

                <h5
                  class="font-size-14 mb-3"
                  style="
                    text-align: justify;
                    font-weight: lighter;
                    margin-top: 5%;
                    margin-bottom: 10%;
                  "
                >
                  <p style="font-weight: bold">
                    3. ¿QUE PUEDO ESPERAR DEL TRATAMIENTO PROPUESTO?
                  </p>
                  El proceso de psicología consta de evaluación, intervención o
                  tratamiento y seguimiento. Toda la información que brinde está
                  cobijada por el secreto profesional y nadie tendrá acceso a
                  ella. El secreto profesional se puede romper (de acuerdo con
                  lo señalado en el artículo 2o, numeral 5o de la Ley 1090 de
                  2006) solo en caso de conocerse que la vida del paciente o la
                  de otras personas esté en riesgo, también cuando existe una
                  situación de abuso hacia niños o adultos mayores, o en caso de
                  que una autoridad legal lo requiera. El éxito del tratamiento
                  depende única y exclusivamente del interés y compromiso del
                  consultante.
                  <p></p>
                  <p style="font-weight: bold">
                    4. RIESGOS DEL TRATAMIENTO PROPUESTO
                  </p>
                  Cualquier tipo de actividad entraña un riesgo inherente. La
                  decisión individual de someterse a un tratamiento o proceso se
                  basa en la comparación del riesgo con el beneficio potencial.
                  Aunque la mayoría de los consultantes no experimentan las
                  siguientes complicaciones, debe conocer cada una de ellas para
                  asegurarse de que comprende los riesgos del tratamiento
                  propuesto; Ansiedad, tristeza, rabia, empeoramiento de los
                  síntomas consultados. En caso de presentar alguno de los
                  síntomas antes mencionados hable abiertamente con el
                  profesional, con el fin de abordarlos.
                  <p></p>
                  Presencia de riesgos adicionales: Existen condiciones médicas
                  que, aunque no implican la imposibilidad de llevar a cabo el
                  tratamiento, aumentan los riesgos que corre el consultante
                  durante todas las etapas del mismo. El consultante declara que
                  ha informado de forma veraz sus antecedes al profesional.
                  <p></p>
                  Resultado no satisfactorio: Existe la posibilidad de que quede
                  insatisfecho con el resultado del proceso.
                  <p></p>
                  <p style="font-weight: bold">
                    5. BENEFICIOS DEL TRATAMIENTO PROPUESTO
                  </p>
                  Reducción de malestar psicológico y emocional, mejorar la
                  calidad de vida, mejoramiento de habilidades interpersonales,
                  generar estrategias efectivas en la solución de problemas,
                  entre otros.
                  <p></p>
                  <p style="font-weight: bold">
                    6. ACEPTACIÓN DE LOS RIEGOS PROPUESTOS
                  </p>
                </h5>

                <div class="row">
                  <div class="col-md-6">
                    <label for="nombres" class="form-label"
                      >Nombres y Apellidos</label
                    >
                    <p>
                      <strong
                        >{{ paciente.nombres }} {{ paciente.apellidos }}</strong
                      >
                    </p>
                  </div>

                  <div class="col-md-6">
                    <label for="documento" class="form-label"
                      >Numero de Documento</label
                    >

                    <p>
                      <strong>{{ paciente.identificacion }}</strong>
                    </p>
                  </div>

                  <h5
                    class="font-size-14 mb-3"
                    style="
                      text-align: justify;
                      font-weight: lighter;
                      margin-top: 5%;
                      margin-bottom: 10%;
                    "
                  >
                    <p style="font-weight: bold">7. SIGNOS DE ALARMA</p>
                    Ante cualquier situación que usted encuentre fuera de lo
                    común o de presentar un incremento del malestar emocional
                    por favor consulte inmediatamente a la línea +57 314 813
                    1016.
                    <p></p>
                    <p style="font-weight: bold">
                      8. EQUIPO INTERDISCIPLINARIO
                    </p>
                  </h5>

                  <div class="col-md-6">
                    <label class="form-label"
                      >Autorizo a que mi caso sea consultado con otros
                      expertos</label
                    >
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="eInterdisciplinario"
                        [ngClass]="{
                          'is-invalid':
                            submitted && form.eInterdisciplinario.errors,
                          'is-valid':
                            submitted && form.eInterdisciplinario.valid
                        }"
                        formControlName="eInterdisciplinario"
                        [value]="true"
                      />
                      <label class="form-check-label" for="eInterdisciplinario">
                        Autorizo
                      </label>
                    </div>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="eInterdisciplinario"
                        [ngClass]="{
                          'is-invalid':
                            submitted && form.eInterdisciplinario.errors,
                          'is-valid':
                            submitted && form.eInterdisciplinario.valid
                        }"
                        formControlName="eInterdisciplinario"
                        [value]="false"
                      />
                      <label class="form-check-label" for="eInterdisciplinario">
                        No Autorizo
                      </label>
                      <div
                        *ngIf="submitted && form.eInterdisciplinario.errors"
                        class="invalid-feedback"
                      >
                        <span *ngIf="form.eInterdisciplinario.errors.required"
                          >Este campo es obligatorio</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label"
                      >¿La consulta esta asociada a situación laboral?</label
                    >

                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="slaboral"
                        id="radioSlaboral1"
                        [ngClass]="{
                          'is-invalid': submitted && form.slaboral.errors,
                          'is-valid': submitted && form.slaboral.valid
                        }"
                        formControlName="slaboral"
                        [value]="true"
                      />
                      <label class="form-check-label" for="radioSlaboral1">
                        SI
                      </label>
                    </div>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="slaboral"
                        id="radioSlaboral2"
                        [ngClass]="{
                          'is-invalid': submitted && form.slaboral.errors,
                          'is-valid': submitted && form.slaboral.valid
                        }"
                        formControlName="slaboral"
                        [value]="false"
                      />
                      <label class="form-check-label" for="radioSlaboral2">
                        NO
                      </label>
                      <div
                        *ngIf="submitted && form.slaboral.errors"
                        class="invalid-feedback"
                      >
                        <span *ngIf="form.slaboral.errors.required"
                          >Este campo es obligatorio</span
                        >
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <h5
                      class="font-size-14 mb-3"
                      style="
                        text-align: justify;
                        font-weight: lighter;
                        margin-top: 5%;
                        margin-bottom: 10%;
                      "
                    >
                      <p style="font-weight: bold">9. GARANTÍA DE ÉXITO</p>
                      No existe garantía de éxito, el profesional pondrá a su
                      disposición todo su talento, conocimiento y experiencia,
                      adicionalmente un equipo de trabajo incluyendo otros
                      especialistas que podrán participar en el tratamiento, sin
                      embargo, no se garantiza que el resultado sea el que usted
                      esperaba, ni tampoco que no necesite nuevos procesos en el
                      futuro.
                      <p></p>
                      <p style="font-weight: bold">
                        10. POSIBILIDAD DE SUSPENDER EL TRATAMIENTO.
                      </p>
                      Es su derecho suspender el tratamiento en el momento en
                      que lo desee, y de hacerlo, se le recomienda manifestar
                      con antelación dicha decisión para recibir una adecuada
                      retroalimentación, recomendación, y/o remisión.
                      <p></p>
                      <p style="font-weight: bold">
                        11. TRATAMIENTOS ALTERNATIVOS
                      </p>
                      Dependiendo de sus expectativas hable con el profesional
                      respecto de que otros tratamientos podrían tener
                      resultados similares, en donde se le brindará informa-
                      ción sobre otros profesionales que estén capacitados para
                      aplicar el tratamiento necesario, en caso de que la
                      problemática este fuera de su área de conocimiento
                      <p></p>
                      <p style="font-weight: bold">
                        12. AUTORIZACIÓN DEL MANEJO DE DATOS
                      </p>
                      He leído, entendido y decido aceptar las condiciones del
                      consentimiento informado. De igual forma autorizo de
                      manera expresa a Psicologa.co para el tratamiento
                      (recopilación, uso, almacenamiento, transferencia y
                      transmisión) de mis datos personales, la cual deberá ser
                      tratada conforme a la Ley 1581 de 2012, el Decreto 1074 de
                      2015 y demás normas que regulen la materia
                      <p></p>
                    </h5>
                  </div>

                  <div class="col-md-12">
                    <p style="font-weight: bold">
                      13. FECHA EN QUE SE FIRMA EL CONSENTIMIENTO INFORMADO
                    </p>
                    <p>{{ formattedDate }}</p>
                  </div>

                  <div class="col-md-12">
                    <label class="form-label"
                      >¿Estoy de acuerdo con los derechos anteriormente
                      brindados.?</label
                    >
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        formControlName="derechos"
                        [value]="true"
                        id="radioDerecho1"
                        [ngClass]="{
                          'is-invalid':
                            submitted &&
                            formConsentimiento.get('derechos')?.errors,
                          'is-valid':
                            submitted &&
                            formConsentimiento.get('derechos')?.valid
                        }"
                      />
                      <label class="form-check-label" for="radioDerecho1">
                        Si
                      </label>
                    </div>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        formControlName="derechos"
                        [value]="false"
                        id="radioDerecho2"
                        [ngClass]="{
                          'is-invalid':
                            submitted &&
                            formConsentimiento.get('derechos')?.errors,
                          'is-valid':
                            submitted &&
                            formConsentimiento.get('derechos')?.valid
                        }"
                      />

                      <label class="form-check-label" for="radioDerecho2">
                        No
                      </label>
                      <div
                        *ngIf="submitted && form.derechos.errors"
                        class="invalid-feedback"
                      >
                        <span *ngIf="form.derechos.errors.required"
                          >Este campo es obligatorio</span
                        >
                      </div>
                    </div>
                  </div>

                  <h5
                    class="font-size-14 mb-3"
                    style="
                      text-align: justify;
                      font-weight: lighter;
                      margin-top: 5%;
                      margin-bottom: 10%;
                    "
                  >
                    Acepto los riesgos del tratamiento propuesto y entiendo que,
                    aunque el profesional y todo su equipo de trabajo ponen a mi
                    disposición su talento y experticia, existe la posibilidad
                    de que cualquiera de los riesgos descritos u otros
                    adicionales se materialicen.
                    <p></p>

                    <div class="form-check">
                      <input
                        class="form-check-input"
                        [ngClass]="{
                          'is-invalid': submitted && form.aceptoRiesgos.errors,
                          'is-valid': submitted && form.aceptoRiesgos.valid
                        }"
                        formControlName="aceptoRiesgos"
                        type="checkbox"
                        name="aceptoRiesgos"
                        id="aceptoRiesgos1"
                      />
                      <label class="form-check-label" for="aceptoRiesgos">
                        Acepto
                      </label>
                      <div
                        *ngIf="submitted && form.aceptoRiesgos.errors"
                        class="invalid-feedback"
                      >
                        <span *ngIf="form.aceptoRiesgos.errors.required"
                          >Este campo es obligatorio</span
                        >
                      </div>
                    </div>
                  </h5>

                  <h5
                    class="font-size-14 mb-3"
                    style="
                      text-align: justify;
                      font-weight: lighter;
                      margin-top: 5%;
                      margin-bottom: 10%;
                    "
                  >
                    He leído, entendido y decido aceptar las condiciones del
                    consentimiento informado. De igual forma autorizo de manera
                    expresa a Psicologa.co para el tratamiento (recopilación,
                    uso, almacenamiento, transferencia y transmisión) de mis
                    datos personales, la cual deberá ser tratada conforme a la
                    Ley 1581 de 2012, el Decreto 1074 de 2015 y demás normas que
                    regulen la materia.
                    <p></p>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        [ngClass]="{
                          'is-invalid':
                            submitted && form.aceptoCondiciones.errors,
                          'is-valid': submitted && form.aceptoCondiciones.valid
                        }"
                        formControlName="aceptoCondiciones"
                        type="checkbox"
                        name="aceptoCondiciones"
                        id="aceptoCondiciones1"
                      />
                      <label class="form-check-label" for="aceptoCondiciones">
                        Acepto
                      </label>
                      <div
                        *ngIf="submitted && form.aceptoCondiciones.errors"
                        class="invalid-feedback"
                      >
                        <span *ngIf="form.aceptoCondiciones.errors.required"
                          >Este campo es obligatorio</span
                        >
                      </div>
                    </div>
                  </h5>
                  <div class="col-md-12">
                    <label for="firma" class="form-label"
                      >Cómo nos conoció?</label
                    >
                    <ng-select
                      [items]="referidos"
                      bindValue="$id"
                      bindLabel="referido"
                      placeholder="Seleccione"
                      appendTo="body"
                      [multiple]="false"
                      formControlName="tReferido"
                      [ngClass]="{
                        'is-invalid': submitted && form.tReferido.errors,
                        'is-valid': submitted && form.tReferido.valid
                      }"
                    >
                    </ng-select>
                  </div>

                  <div class="col-md-12">
                    <label for="notas" class="form-label">Notas</label>
                    <input
                      class="form-control"
                      [ngClass]="{
                        'is-invalid': submitted && form.notas.errors,
                        'is-valid': submitted && form.notas.valid
                      }"
                      type="text"
                      formControlName="notas"
                    />
                    <div
                      *ngIf="submitted && form.notas.errors"
                      class="invalid-feedback"
                    >
                      <span *ngIf="form.notas.errors.required"
                        >Este campo es obligatorio</span
                      >
                    </div>
                  </div>

                  <div class="text-end mt-2">
                    <button
                      id="btn-save-event"
                      (click)="createFirmaConsentimiento()"
                      class="btn btn-primary"
                    >
                      Firmar Consentimiento
                    </button>
                  </div>

                  <div *ngIf="submitted">
                    <p *ngIf="error" class="text-danger" style="color: re">
                      {{ error }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <ng-template #loadingTemplate>
    <p>Cargando datos del paciente...</p>
  </ng-template>
  <!-- <p *ngIf="error">{{ error }}</p> -->
</div>
